/**
 * ___Type Imports___
 * @typedef {import('vuex').ActionContext} ActionContext
 * @typedef {import('vuex').ActionPayload} ActionPayload
 *
 * @typedef {Object} AppState
 * @property {Array<Layer>} layers
 */

/** @type {AppState} */
const baseState = {
  layers: [],
  usage: {},
};

const baseMutations = {
  /**
   *
   * @param {AppState} state state object
   * @param {ActionPayload} payload array of layers objects
   */
  setLayers: (state, payload) => {
    state.layers = payload;
  },
  setUsage: (state, payload) => {
    state.usage = payload;
  },
};

const baseActions = {};

export {
  baseState,
  baseMutations,
  baseActions,
};
